import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ReactSession } from "react-client-session";
import { useNavigate } from "react-router-dom";
import axios from "axios";
ReactSession.setStoreType("localStorage");

const Accounts = () => {
  const userId = ReactSession.get("welbeinguserId");
  const profile = ReactSession.get("welbeingprofile");
  const [addresses, setAddresses] = useState({});
  const [orders, setorders] = useState({});
  const [error, setError] = useState("");
  const userName = ReactSession.get("welbeinguserName");
  const Email = ReactSession.get("welbeingemail");
  const phonenumber = ReactSession.get("welbeingphonenumber");
  const Gender = ReactSession.get("welbeinggender");
  const Profile = ReactSession.get("welbeingprofile");
  const [profilename, setprofilename] = useState("");
  const [profileemail, setprofileemail] = useState("");
  const [profilenumber, setprofilenumber] = useState("");
  const [profilegender, setprofilegender] = useState("");
  const [profileimage, setprofileimage] = useState(null);
  const [profileimgname, setprofileimgname] = useState(Profile);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

   if(userId  <= 0 ){
      navigate('/login');
   }

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const name = userName;
    const email = Email;
    const number = phonenumber;
    const gender = Gender;
    const profile = Profile;

    setprofilename(name);
    setprofileemail(email);
    setprofilenumber(number);
    setprofilegender(gender);
    setprofileimage(profile);
  }, []);

  const handleprofileName = (event) => {
    setprofilename(event.target.value);
  };
  const handleprofileEmail = (event) => {
    setprofileemail(event.target.value);
  };
  const handleprofileNumber = (event) => {
    setprofilenumber(event.target.value);
  };
  const handleprofileGender = (event) => {
    setprofilegender(event.target.value);
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const filename = event.target.files[0].name;
    setprofileimage(file);
    setprofileimgname(filename);
  };

  const handleprofileSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("cust_id", userId);

    // Check if content has changed
    formData.append("name", profilename);
    formData.append("email", profileemail);
    formData.append("phonenumber", profilenumber);
    formData.append("gender", profilegender);
    formData.append("images", profileimage);

    try {
      const response = await axios.post(
        "https://api.welbeing.in/customer/update-profile/",
        formData
      );
      //   console.log(response.data)
      ReactSession.set("welbeinguserName", response.data.data[0].name);
      ReactSession.set("welbeingemail", response.data.data[0].email);
      ReactSession.set(
        "welbeingphonenumber",
        response.data.data[0].phonenumber
      );
      ReactSession.set("welbeinggender", response.data.data[0].gender);
      ReactSession.set("welbeingprofile", response.data.data[0].profile);
      // navigate('/account');
      // alert("profile changes updatd successfully.");
    } catch (error) {
      console.error("There was a problem with login:", error);
      setError("Invalid email or password");
    }
  };

  const fetchAddressData = async () => {
    try {
      const response = await axios.post(
        "https://api.welbeing.in/address/get-address/",
        { cust_id: userId }
      );
      const fetchedAddresses = response.data;
      setAddresses(fetchedAddresses);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchAddressData();
  }, []);

  const handleAddressdelete = async (addressId) => {
    try {
      const response = await axios.post(
        `https://api.welbeing.in/address/delete-address/`,
        { id: addressId }
      );
      fetchAddressData();
    } catch (error) {
      console.error("There was a problem with login:", error);
      setError("Not Inserted");
    }
  };
  // orders
  useEffect(() => {
    const orders = async () => {
      try {
        const response = await axios.post(
          "https://api.welbeing.in/orders/get-orders/",
          { cust_id: userId }
        );
        if (response.data.status === "success") {
          setorders(response.data.data);
          //  console.log(response.data.data)
        }
        // console.log('Login successful:', response.data);
      } catch (err) {
        setError(err.message);
      }
    };
    orders();
  }, []);

  //wishlist

  // Wishlist
  const WishlistCount = () => {
    const items = JSON.parse(sessionStorage.getItem("wishlistItems")) || [];
    setWishlistItems(items);
  };
  useEffect(() => {
    WishlistCount();
    window.addEventListener("wishlistUpdated", WishlistCount);
    return () => {
      window.removeEventListener("wishlistUpdated", WishlistCount);
    };
  }, []);

  // Remove wishlist
  const removeFromWishlist = (index) => {
    const updatedWishlist = [...wishlistItems];
    updatedWishlist.splice(index, 1);
    sessionStorage.setItem("wishlistItems", JSON.stringify(updatedWishlist));
    setWishlistItems(updatedWishlist);
    window.dispatchEvent(new Event("wishlistUpdated"));
  };

  //logout
  const handleLogout = () => {
    ReactSession.set("welbeinguserId", "0");
    ReactSession.set("welbeinguserName", "");
    ReactSession.set("welbeingemail", "");
    ReactSession.set("welbeingprofile", "");
    ReactSession.set("welbeingphonenumber", "");
    ReactSession.set("welbeinggender", "");

    sessionStorage.removeItem("cartItems");
    sessionStorage.removeItem("coupon");
    sessionStorage.removeItem("offer");
    // Perform any other cleanup tasks or redirection if needed
    navigate("/login"); // Redirect to login page after logout
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      <Header />
      <main className="main">
        {/* Breadcrumb Start */}
        <div className="breadcrumb-wrap" id="breadcrumb-margin">
          <div className="banner" style={{minHeight:'10px'}}>
            <img
              className="bg-img bg-top"
              src="assets/images/inner-page/banner-p.webp"
              alt="banner"
            />

            <div className="container-lg">
              <div className="breadcrumb-box">
                <div className="heading-box">
                  <h1>User Dashboard</h1>
                </div>
                <ol className="breadcrumb">
                  <li>
                    <a href="/">Home</a>
                  </li>

                  <li>
                    <a href="">
                      <i data-feather="chevron-right"></i>
                    </a>
                  </li>

                  <li className="current">
                    <a href="">User Dashboard</a>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* Breadcrumb End */}

        {/* Dashboard Start */}

        <section className="user-dashboard">
          <div className="container-lg">
            <div className="row g-3 g-xl-4 tab-wrap">
              <div className="col-lg-4 col-xl-3">
                <button
                  className="setting-menu btn-solid btn-sm d-lg-none"
                  onClick={toggleSidebar}
                >
                  Setting Menu <i className="arrow"></i>
                </button>
                <div
                  className={`side-bar ${
                    isSidebarOpen ? "show-menu open" : ""
                  }`}
                >
                  <span
                    id="closeSidebar"
                    className="back-side d-lg-none"
                    onClick={closeSidebar}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: "92px",
                      right: "15px",
                      padding: "8px",
                      borderRadius: "50%",
                      transition: "background-color 0.2s",
                      
                    }}
                  >
                    
                    <i data-feather="x"></i>
                  </span>
                  <div className="profile-box">
                    <div className="img-box">
                      <img
                        src={`https://welbeing.in/admin_panel/customer_data/${profile}`}
                        alt="profile"
                      />{" "}
                    </div>

                    <div className="user-name">
                      <h5> {ReactSession.get("welbeinguserName")}</h5>
                      <h6>{ReactSession.get("welbeingemail")}</h6>
                    </div>
                  </div>

                  <ul
                    className="nav nav-tabs nav-tabs2"
                    id="myTab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="dashboard-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#dashboard"
                        type="button"
                        role="tab"
                        aria-controls="dashboard"
                        aria-selected="true"
                      >
                        Dashboard
                        <span>
                          <i data-feather="chevron-right"></i>
                        </span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="orders-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#orders"
                        type="button"
                        role="tab"
                        aria-controls="orders"
                        aria-selected="false"
                      >
                        Orders
                        <span>
                          <i data-feather="chevron-right"></i>
                        </span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="wishlist-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#wishlist"
                        type="button"
                        role="tab"
                        aria-controls="orders"
                        aria-selected="false"
                      >
                        Wishlist
                        <span>
                          <i data-feather="chevron-right"></i>
                        </span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="savedAddress-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#savedAddress"
                        type="button"
                        role="tab"
                        aria-controls="savedAddress"
                        aria-selected="false"
                      >
                        Saved Address
                        <span>
                          <i data-feather="chevron-right"></i>
                        </span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#profile"
                        type="button"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                      >
                        Profile
                        <span>
                          <i data-feather="chevron-right"></i>
                        </span>
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a onClick={handleLogout}>
                        <button className="nav-link">
                          Logout
                          <span>
                            <i data-feather="chevron-right"></i>
                          </span>
                        </button>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-8 col-xl-9">
                <div className="right-content tab-content" id="myTabContent">
                  {/* User Dashboard Start */}
                  <div
                    className="tab-pane show active"
                    id="dashboard"
                    role="tabpanel"
                    aria-labelledby="dashboard-tab"
                  >
                    <div className="dashboard-tab">
                      <div className="title-box3">
                        <h3>Welcome {ReactSession.get("welbeinguserName")}</h3>
                        <p>
                          From your account dashboard you can view your recent
                          orders, manage your shipping and billing addresses,
                          <br />
                          and edit your password and account details
                        </p>
                      </div>

                      <div className="row g-0 option-wrap">
                        <div className="col-sm-6 col-xl-4">
                          <a href="" data-class="orders" className="tab-box">
                            <i data-feather="shopping-bag"></i>
                            <h5>Orders</h5>
                            <p>See order history of previous orders</p>
                          </a>
                        </div>
                        <div className="col-sm-6 col-xl-4">
                          <a href="" data-class="wishlist" className="tab-box">
                            <i data-feather="heart"></i>
                            <h5>Wishlist</h5>
                            <p>
                              Your Wishlist expire within 24h please complete
                              Checkout
                            </p>
                          </a>
                        </div>
                        <div className="col-sm-6 col-xl-4">
                          <a
                            href=""
                            data-class="savedAddress"
                            className="tab-box"
                          >
                            <i data-feather="map-pin"></i>
                            <h5>Saved Address</h5>
                            <p>You saved 0 address for delivery</p>
                          </a>
                        </div>
                        <div className="col-sm-6 col-xl-4">
                          <a href="" data-class="profile" className="tab-box">
                            <i data-feather="user"></i>
                            <h5>Profile</h5>
                            <p>
                              Complete your profile details there are some
                              Information missing
                            </p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* User Dashboard End */}

                  {/* Order Tabs Start */}
                  <div
                    className="tab-pane"
                    id="orders"
                    role="tabpanel"
                    aria-labelledby="orders-tab"
                  >
                    <div className="cart-wrap order-content">
                      <div className="title-box3">
                        <h3>My Orders</h3>
                        <p>
                          Hi thanks for placing a delivery order with Welbeing!
                          Your order should be home with you in soon
                        </p>
                      </div>

                      <div className="order-wraper">
                        <div className="payment-section">
                          <div className="row g-3 g-xl-4">
                            {Array.isArray(orders) &&
                              orders
                                .slice()
                                .reverse()
                                .map((orders) => (
                                  <div class="col-sm-6 col-xl-4">
                                    <div class="payment-card">
                                      <div class="card-details">
                                        <h5>Order ID : {orders.order_id}</h5>
                                      </div>

                                      <div class="card-details-wrap">
                                        <div class="card-details">
                                          <span>{orders.count} Items</span>
                                          <br></br>
                                          <span>Amount : ₹ {orders.total}</span>
                                          <br></br>
                                          <a
                                            href={`/track?id=${orders.order_id}`}
                                          >
                                            <button
                                              type="button"
                                              class="btn btn-solid line-none rounded-pill mt-2"
                                            >
                                              View Details
                                              <i class="arrow"></i>
                                            </button>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Order Tabs End */}

                  {/* Saved Address Tabs Start */}
                  <div
                    className="tab-pane"
                    id="savedAddress"
                    role="tabpanel"
                    aria-labelledby="savedAddress-tab"
                  >
                    <div className="address-tab">
                      <div className="title-box3">
                        <h3>Your Saved Address</h3>
                        <p>
                          Here is your saved address, from here you can easily
                          add or modify your address
                        </p>
                      </div>

                      <div className="row g-3 g-md-4">
                        {addresses &&
                          addresses.data &&
                          addresses.data
                            .slice()
                            .reverse()
                            .slice(-4)
                            .map((address) => (
                              <div
                                className="col-lg-6 col-md-12 col-12 mt-4"
                                style={{ minHeight: "220px" }}
                              >
                                <div className="address-box checked">
                                  <div className="radio-box">
                                    <div>
                                      <label
                                        className="radio-label"
                                        htmlFor={`address-${address.id}`}
                                      ></label>
                                    </div>
                                    <span className="badges badges-pill badges-theme">
                                      {address.name}
                                    </span>
                                    <div className="option-wrap">
                                      <button
                                        className="delet ms-0"
                                        onClick={() =>
                                          handleAddressdelete(address.id)
                                        }
                                      >
                                        <i class="fa fa-trash" style={{color:"#767676"}}></i>
                                      </button>
                                    </div>
                                  </div>

                                  <div className="address-detail">
                                    <p className="product-short-desc">
                                      <small>{address.address}</small>
                                    </p>
                                    <small className="content-color font-default">
                                      Mobile:{" "}
                                      <span className="title-color font-default fw-500">
                                        {address.phonenumber}
                                      </span>
                                    </small>
                                    <br />
                                    <small className="content-color font-default">
                                      Email:{" "}
                                      <span className="title-color font-default fw-500">
                                        {address.email}
                                      </span>
                                    </small>
                                    <br />
                                    <small className="content-color font-default mt-1">
                                      City:{" "}
                                      <span className="title-color font-default fw-500">
                                        {address.city}
                                      </span>
                                    </small>
                                    <br />
                                    <small className="content-color font-default mt-1">
                                      Pincode:{" "}
                                      <span className="title-color font-default fw-500">
                                        {address.pincode}
                                      </span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                            ))}
                        <div
                          className="col-md-6 col-lg-12 col-xl-6"
                          style={{ minHeight: "170px" }}
                        >
                          <div
                            className="address-box add-new d-flex flex-column gap-2 align-items-center justify-content-center"
                            data-bs-toggle="modal"
                            data-bs-target="#addNewAddress"
                          >
                            <a href="/addaddress">
                              {" "}
                              <span className="plus-icon">
                                <i data-feather="plus"></i>
                              </span>
                            </a>
                            <h4 className="theme-color font-xl fw-500">
                              Add New Address
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Saved Address Tabs End */}

                  {/* Payment Tabs Start */}
                  <div
                    className="tab-pane"
                    id="wishlist"
                    role="tabpanel"
                    aria-labelledby="wishlist-tab"
                  >
                    <div className="payment-tab">
                      {wishlistItems.length === 0 ? (
                        <div className="empty-wishlist text-center py-5">
                          <p
                            style={{
                              fontSize: "24px",
                              fontWeight: "500",
                              color: "#555",
                            }}
                          >
                            Your wishlist is empty
                          </p>
                          <p className="text-muted mb-4">
                            Save your favorite items here
                          </p>
                          <a
                            href="/shop"
                            class="btn btn-outline btn-sm addtocart-btn"
                          >
                            Shop Now<i class="arrow"></i>
                          </a>
                        </div>
                      ) : (
                        <div className="row g-3 g-xl-4 ratio_asos">
                          {wishlistItems.map((wishlist, index) => (
                            <div
                              className="col-12 col-sm-6 col-md-4 col-lg-3"
                              key={index}
                            >
                              <div className="product-card product-wishlist">
                                <div className="img-box">
                                  <a
                                    href={`singleproduct?id=${wishlist.id}`}
                                    className="primary-img"
                                  >
                                    <img
                                      src={`https://welbeing.in/admin_panel/product_data/${wishlist.image}`}
                                      alt={wishlist.name}
                                    />
                                  </a>
                                  <button
                                    className="delete-button"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      removeFromWishlist(index);
                                    }}
                                  >
                                    <i data-feather="x"></i>
                                  </button>
                                </div>
                                <div className="content-wrap">
                                  <div className="content-box">
                                    <a href={`singleproduct?id=${wishlist.id}`}>
                                      <h5>{wishlist.name}</h5>
                                      <span>₹{wishlist.price}</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Payment Tabs End */}

                  {/* Profile Tabs Start */}
                  <div
                    className="tab-pane"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div className="profile">
                      <div className="title-box3">
                        <h3>Basics Information</h3>
                      </div>

                      <form
                        onSubmit={handleprofileSubmit}
                        className="custom-form form-pill"
                        method="post"
                      >
                        <div className="row g-3 g-xl-4">
                          <div className="col-sm-6">
                            <div className="input-box">
                              <label htmlFor="fullname">Full Name</label>
                              <input type="hidden" name="id" value="11" />
                              <input
                                className="form-control"
                                id="fullname"
                                type="text"
                                name="name"
                                value={profilename}
                                onChange={handleprofileName}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="input-box">
                              <label htmlFor="email">Email</label>
                              <input
                                className="form-control"
                                id="email"
                                type="email"
                                name="email"
                                value={profileemail}
                                onChange={handleprofileEmail}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="input-box">
                              <label htmlFor="mobile">Mobile</label>
                              <input
                                maxLength="10"
                                className="form-control"
                                id="mobile"
                                type="number"
                                value={profilenumber}
                                onChange={handleprofileNumber}
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="input-box">
                              <label htmlFor="gender">Gender</label>
                              <select
                                name="gender"
                                id="gender"
                                className="form-control"
                                value={profilegender}
                                onChange={handleprofileGender}
                              >
                                <option selected hidden disabled>
                                  Select Your Gender
                                </option>
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="input-box">
                              <label htmlFor="photo">Profile Photo</label>
                              <input
                                className="form-control"
                                id="photo"
                                name="profile"
                                accept="image/png, image/jpeg, image/jpg, image/pdf, image/webp"
                                onChange={handleFileChange}
                                type="file"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="btn-box">
                          <button
                            name="editprofile"
                            className="btn-solid btn-sm"
                          >
                            Save Changes <i className="arrow"></i>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  {/* Profile Tabs End */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Dashboard End */}
      </main>
      <Footer />
    </>
  );
};

export default Accounts;
